export const REDUCER_NAME = 'projectSlice';

export interface iProjectDTO {
  projectZip: File;                    // uploaded zip file
  images: File[];                      // at least one image required
  title: string;                       // project title
  description: string;                 // project description
  amount: number;                      // project amount
  status?: "inProcess" | "success";    // optional status
}

export interface iProjectResponse {
  id: string;
  projectTitle: string;
  projectDescription: string;
  projectAmount: number;
  projectStatus: "inProcess" | "success";
  projectZipUrl: string;               // uploaded zip file URL
  projectImages: string[];             // array of image URLs
  createdAt: string;
  updatedAt: string;
}

export interface iProjectState {
  projectList: iProjectResponse[] | null;
  adminProjectList:iProjectResponse[] | null;
  isLoading: boolean;
  errorMessage: string | null;
}
